import React, {Component} from 'react';

export default class InputWithLabel extends Component {

    render() {
        return (
            <div className="input-container">
                {this.props.label && (
                    <span className="static-text">{this.props.label}</span>
                )}
                <input type={this.props.type ? this.props.type : "text"}
                       placeholder={this.props.placeholder ? this.props.placeholder : "Enter Value"}
                       className={"text-input " + (this.props.showError ? "invalid" : "")}
                       onChange={this.props.handleChange} value={this.props.value}
                       max={this.props.max ? this.props.max : ""}
                       min={this.props.min ? this.props.min : ""}
                       disabled={this.props.disabled ? true : false}
                />
            </div>
        );
    }
}
